import { Component, Input } from '@angular/core'
import { PointingListModel } from '../../models/pointing-system.models'
import { TranslateService } from '@ngx-translate/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import {
	PointingSystemTabs,
	PointsStatusEnum,
} from '../../models/pointing-system.enums'

@Component({
	selector: 'app-points-history-table',
	templateUrl: './points-history-table.component.html',
	styleUrl: './points-history-table.component.scss',
})
export class PointsHistoryTableComponent {
	@Input() pointsHistoryList!: PointingListModel[]
	@Input() filter = {
		countryId: 224,
		activeTab: 1,
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
	}
	@Input() totalCount: number = 0

	statusEnum = this.SharedService.returnEnumArray(PointingSystemTabs)
	pointsStatusEnum = this.SharedService.returnEnumArray(PointsStatusEnum)
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService
	) {}
}
